import React from "react";

export default () => (
  <div className="bold bg-light border-top p-2 d-flex">
    <p className="m-0">Coming Soon...</p>
  </div>
);



// WEBPACK FOOTER //
// ./src/routes/Stickers/index.js